import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';
import topimage      from '../../Images/Emaar/emaarherosection.png';
import locationimage from '../../Images/Emaar/locationimage.jpg';
import emaartower from '../../Images/Emaar/khalifa_tower-removebg-preview.png'
import { RegisterButton } from './RegisterButton';

// ── بيانات المواقع ──────────────────────────────────────────
const locations = [
  {
    minutes: '5',
    label:   'مطار آل مكتوم',
    svg: (
      <svg width="36" height="36" viewBox="0 0 24 24" fill="currentColor">
        <path d="M21 16v-2l-8-5V3.5A1.5 1.5 0 0 0 11.5 2 1.5 1.5 0 0 0 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5z"/>
      </svg>
    ),
  },
  {
    minutes: '5',
    label:   'مارينا الخليج التجاري',
    svg: (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 17l1-5h16l1 5H3z"/>
        <path d="M6 12V7a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v5"/>
        <path d="M3 21h18"/>
        <path d="M12 5V2"/>
      </svg>
    ),
  },
  {
    minutes: '35',
    label:   'برج خليفة',
    image:   emaartower,
  },
  {
    minutes: '35',
    label:   'دبي مول',
    svg: (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
        <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>
        <line x1="3" y1="6" x2="21" y2="6"/>
        <path d="M16 10a4 4 0 0 1-8 0"/>
      </svg>
    ),
  },
];

export const Locationimage = () => {
  const heroRef    = useRef(null);
  const heroTxtRef = useRef(null);
  const sectionRef = useRef(null);
  const leftRef    = useRef(null);
  const rightRef   = useRef(null);
  const cardsRef   = useRef([]);

  // ── Hero animation ───────────────────────────────────────────
  useEffect(() => {
    const hero = heroRef.current;
    const txt  = heroTxtRef.current;
    if (!hero || !txt) return;

    gsap.set(txt, { opacity: 0, y: 40 });

    const obs = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting)
          gsap.to(txt, { opacity: 1, y: 0, duration: 1, ease: 'power3.out', delay: 0.3 });
        else
          gsap.set(txt, { opacity: 0, y: 40 });
      });
    }, { threshold: 0.2 });

    obs.observe(hero);
    return () => obs.disconnect();
  }, []);

  // ── Location section animation ───────────────────────────────
  useEffect(() => {
    const section = sectionRef.current;
    const left    = leftRef.current;
    const right   = rightRef.current;
    const cards   = cardsRef.current.filter(Boolean);
    if (!section) return;

    gsap.set(left,  { opacity: 0, x: -40 });
    gsap.set(right, { opacity: 0, x:  40 });
    gsap.set(cards, { opacity: 0, y: 30, scale: 0.95 });

    const obs = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          gsap.to(left,  { opacity: 1, x: 0, duration: 0.9, ease: 'power3.out' });
          gsap.to(right, { opacity: 1, x: 0, duration: 0.9, ease: 'power3.out', delay: 0.15 });
          gsap.to(cards, { opacity: 1, y: 0, scale: 1, duration: 0.6, ease: 'power3.out', stagger: 0.1, delay: 0.3 });
        } else {
          gsap.set(left,  { opacity: 0, x: -40 });
          gsap.set(right, { opacity: 0, x:  40 });
          gsap.set(cards, { opacity: 0, y: 30, scale: 0.95 });
        }
      });
    }, { threshold: 0.1 });

    obs.observe(section);
    return () => obs.disconnect();
  }, []);

  return (
    <>
      {/* ══════════════════════════════════════════════
          TOP IMAGE
      ══════════════════════════════════════════════ */}
      <div
        ref={heroRef}
        style={{
          position: 'relative',
          width:    '100%',
          height:   'clamp(320px, 55vw, 600px)',
          overflow: 'hidden',
        }}
      >
        <img
          src={topimage}
          alt="Emaar Golf Field"
          style={{
            width:          '100%',
            height:         '100%',
            objectFit:      'cover',
            objectPosition: 'center',
            display:        'block',
          }}
        />

        {/* Overlay */}
        <div style={{
          position:   'absolute',
          inset:      0,
          background: 'linear-gradient(to left, rgba(0,0,0,0.72) 0%, rgba(0,0,0,0.35) 55%, rgba(0,0,0,0.08) 100%)',
        }} />

        {/* النص */}
        <div
          ref={heroTxtRef}
          style={{
            position:       'absolute',
            inset:          0,
            display:        'flex',
            flexDirection:  'column',
            justifyContent: 'center',
            alignItems:     'flex-end',
            padding:        '0 6vw',
            textAlign:      'right',
            direction:      'rtl',
            fontFamily:     "'Cairo', sans-serif",
            opacity:        0,
          }}
        >
          {/* Badge */}
          <div style={{
            background:     'rgba(200,160,74,0.2)',
            backdropFilter: 'blur(8px)',
            border:         '1px solid rgba(200,160,74,0.5)',
            color:          '#f0d080',
            fontSize:       '11px',
            fontWeight:     '700',
            letterSpacing:  '3px',
            padding:        '7px 18px',
            borderRadius:   '30px',
            marginBottom:   '20px',
            textTransform:  'uppercase',
          }}>
            EMAAR SOUTH · DUBAI
          </div>

          <h2 style={{
            color:      '#fff',
            fontSize:   'clamp(28px, 5vw, 58px)',
            fontWeight: '900',
            lineHeight: '1.2',
            margin:     '0 0 14px 0',
            textShadow: '0 2px 20px rgba(0,0,0,0.4)',
          }}>
            الموقع
          </h2>

          <p style={{
            color:      'rgba(255,255,255,0.85)',
            fontSize:   'clamp(14px, 1.8vw, 18px)',
            maxWidth:   '480px',
            lineHeight: '1.7',
            margin:     0,
          }}>
            في قلب إعمار الجنوب، وسط أرقى المجتمعات السكنية في دبي
          </p>

          <div style={{
            width:        '60px',
            height:       '3px',
            background:   'linear-gradient(to left, #c8a04a, #f0d080)',
            borderRadius: '2px',
            marginTop:    '20px',
            marginBottom: '28px',
          }} />

          {/* ── زرار التواصل ── */}
          {/* <div style={{ alignSelf: 'flex-end' }}>
            <RegisterButton label="تواصل معنا" />
          </div> */}
        </div>
      </div>

      {/* ══════════════════════════════════════════════
          LOCATION SECTION
      ══════════════════════════════════════════════ */}
      <section
        ref={sectionRef}
        style={{
          background: '#fff',
          padding:    '90px 6vw 80px',
          fontFamily: "'Cairo', sans-serif",
          direction:  'rtl',
          overflow:   'hidden',
        }}
      >
        <div style={{
          display:             'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap:                 '60px',
          alignItems:          'center',
        }}>

          {/* ── يسار: الخريطة ── */}
          <div
            ref={leftRef}
            style={{
              position:     'relative',
              borderRadius: '20px',
              overflow:     'hidden',
              boxShadow:    '0 20px 60px rgba(0,0,0,0.12)',
              opacity:      0,
            }}
          >
            {/* Corner accents */}
            {[
              { top: '14px',    right: '14px',  borderTop:    '2px solid #c8a04a', borderRight:  '2px solid #c8a04a', borderRadius: '0 2px 0 0' },
              { top: '14px',    left:  '14px',  borderTop:    '2px solid #c8a04a', borderLeft:   '2px solid #c8a04a', borderRadius: '2px 0 0 0' },
              { bottom: '14px', right: '14px',  borderBottom: '2px solid #c8a04a', borderRight:  '2px solid #c8a04a', borderRadius: '0 0 2px 0' },
              { bottom: '14px', left:  '14px',  borderBottom: '2px solid #c8a04a', borderLeft:   '2px solid #c8a04a', borderRadius: '0 0 0 2px' },
            ].map((s, i) => (
              <div key={i} style={{ position: 'absolute', width: '24px', height: '24px', zIndex: 2, ...s }} />
            ))}

            <img
              src={locationimage}
              alt="الموقع"
              style={{ width: '100%', display: 'block', objectFit: 'cover', minHeight: '340px' }}
            />

            {/* Badge على الخريطة */}
            <div style={{
              position:       'absolute',
              bottom:         '20px',
              right:          '20px',
              background:     'rgba(200,160,74,0.95)',
              backdropFilter: 'blur(8px)',
              borderRadius:   '10px',
              padding:        '10px 16px',
              zIndex:         2,
            }}>
              <p style={{ margin: 0, color: '#fff', fontSize: '12px', fontWeight: '700', letterSpacing: '1px' }}>
                📍 إعمار الجنوب — دبي
              </p>
            </div>
          </div>

          {/* ── يمين: التفاصيل ── */}
          <div ref={rightRef} style={{ opacity: 0 }}>

            <p style={{
              fontSize:      '11px',
              fontWeight:    '700',
              color:         '#c8a04a',
              letterSpacing: '4px',
              textTransform: 'uppercase',
              margin:        '0 0 14px 0',
            }}>
              LOCATION
            </p>

            <h2 style={{
              fontSize:   'clamp(26px, 3.5vw, 42px)',
              fontWeight: '900',
              color:      '#1a1a1a',
              margin:     '0 0 16px 0',
              lineHeight: '1.2',
            }}>
              الموقع
            </h2>

            <div style={{
              width:        '55px',
              height:       '3px',
              background:   'linear-gradient(to left, #c8a04a, #f0d080)',
              borderRadius: '2px',
              marginBottom: '24px',
            }} />

            <p style={{
              fontSize:   'clamp(14px, 1.5vw, 16px)',
              color:      '#444',
              lineHeight: '1.95',
              margin:     '0 0 14px 0',
            }}>
              يقع مشروع <strong style={{ color: '#1a1a1a' }}>جولف فيلد</strong> ضمن مجتمع{' '}
              <strong style={{ color: '#1a1a1a' }}>إعمار الجنوب</strong> في منطقة{' '}
              <strong style={{ color: '#1a1a1a' }}>دبي الجنوب</strong>، ويتمتع بموقع استراتيجي
              يربطه بأهم الطرق الرئيسية في دبي.
            </p>

            <p style={{
              fontSize:   'clamp(14px, 1.5vw, 16px)',
              color:      '#444',
              lineHeight: '1.95',
              margin:     '0 0 36px 0',
            }}>
              كما يتميز بقربه من{' '}
              <strong style={{ color: '#1a1a1a' }}>مطار آل مكتوم الدولي</strong> وشبكة الطرق
              الحيوية، مما يتيح للسكان الوصول بسهولة إلى وجهات رئيسية مثل{' '}
              <strong style={{ color: '#1a1a1a' }}>إكسبو سيتي دبي</strong> و
              <strong style={{ color: '#1a1a1a' }}>دبي مارينا</strong>.{' '}
              <span style={{ color: '#c8a04a' }}>✦</span>
            </p>

            {/* ── بطاقات المسافات ── */}
            <div style={{
              display:             'grid',
              gridTemplateColumns: 'repeat(2, 1fr)',
              gap:                 '14px',
            }}>
              {locations.map((loc, i) => (
                <div
                  key={i}
                  ref={(el) => (cardsRef.current[i] = el)}
                  onMouseEnter={(e) => {
                    gsap.to(e.currentTarget, {
                      y: -5, boxShadow: '0 12px 32px rgba(200,160,74,0.18)',
                      borderColor: '#c8a04a', duration: 0.25,
                    });
                    const icon = e.currentTarget.querySelector('.loc-icon');
                    if (icon) gsap.to(icon, { color: '#c8a04a', scale: 1.1, duration: 0.25 });
                  }}
                  onMouseLeave={(e) => {
                    gsap.to(e.currentTarget, {
                      y: 0, boxShadow: 'none',
                      borderColor: '#e8e0d0', duration: 0.25,
                    });
                    const icon = e.currentTarget.querySelector('.loc-icon');
                    if (icon) gsap.to(icon, { color: '#b8903a', scale: 1, duration: 0.25 });
                  }}
                  style={{
                    border:       '1px solid #e8e0d0',
                    borderRadius: '14px',
                    padding:      '20px 16px',
                    textAlign:    'center',
                    background:   '#fdfcf9',
                    position:     'relative',
                    overflow:     'hidden',
                    opacity:      0,
                    transition:   'border-color 0.25s ease, box-shadow 0.25s ease',
                    cursor:       'default',
                  }}
                >
                  {/* Top accent */}
                  <div style={{
                    position:     'absolute',
                    top:          0,
                    left:         '50%',
                    transform:    'translateX(-50%)',
                    width:        '36px',
                    height:       '3px',
                    background:   'linear-gradient(to left, #c8a04a, #f0d080)',
                    borderRadius: '0 0 4px 4px',
                  }} />

                  {/* ✅ صورة أو أيقونة */}
                  {loc.image ? (
                    <div style={{
                      width:        '64px',
                      height:       '84px',
                      borderRadius: '12px',
                      overflow:     'hidden',
                      margin:       '0 auto 10px',
                    }}>
                      <img
                        src={loc.image}
                        alt={loc.label}
                        style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'top' }}
                      />
                    </div>
                  ) : (
                    <div
                      className="loc-icon"
                      style={{ color: '#b8903a', marginBottom: '10px', display: 'flex', justifyContent: 'center' }}
                    >
                      {loc.svg}
                    </div>
                  )}

                  {/* الدقائق */}
                  <p style={{
                    fontSize:   'clamp(20px, 2.5vw, 26px)',
                    fontWeight: '900',
                    color:      '#1a1a1a',
                    margin:     '0 0 4px 0',
                  }}>
                    {loc.minutes}{' '}
                    <span style={{ fontSize: '13px', fontWeight: '600', color: '#999' }}>دقيقة</span>
                  </p>

                  {/* الاسم */}
                  <p style={{
                    fontSize:   'clamp(11px, 1.3vw, 13px)',
                    fontWeight: '600',
                    color:      '#888',
                    margin:     0,
                    lineHeight: '1.3',
                  }}>
                    {loc.label}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};